import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  private history: string[] = [];
  private titleSubject = new BehaviorSubject<string>(''); // default empty
  public title$ = this.titleSubject.asObservable();

  constructor(private router: Router) {
    // this.router.events
    //   .pipe(filter(event => event instanceof NavigationEnd))
    //   .subscribe((event: NavigationEnd) => {
    //     const url = (event as NavigationEnd).urlAfterRedirects;
    //     this.history.push(url);

    //     // 🔹 Map routes to titles dynamically
    //     const title = this.mapRouteToTitle(url);
    //     this.titleSubject.next(title);
    //   });
  }

  private mapRouteToTitle(url: string): string {
    const routeTitles: { [key: string]: string } = {
      'sign-in': 'Sign In',
      'sign-up': 'Sign Up',
      'on-boarding': 'On Boarding',
      'forgot-password': 'Forgot Password',
      'my-profile': 'My Profile',
      'my-wallet': 'My Wallet',
      'settings': 'Settings',
      'notifications': 'Notifications',
      'help-center': 'Help Center',
      'terms': 'Terms & Conditions',
      'privacy': 'Privacy Policy',
      'discover': 'Discover',
      'quests': 'Quests',
      'card': 'Card',
      'marketplace': 'Marketplace',
      'profile': 'Profile',
      'partner': 'Partner',
    };

    const cleanUrl = url.split('?')[0].replace(/^\/+/, '');

    return routeTitles[cleanUrl] || 'App';
  }


  public getPreviousUrl(): string | null {
    if (this.history.length > 1) {
      return this.history[this.history.length - 2];
    }
    return null;
  }

  public back(): void {
    if (this.history.length > 1) {
      this.history.pop();
      const previousUrl = this.history.pop();
      if (previousUrl) {
        this.router.navigateByUrl(previousUrl);
      }
    } else {
      this.router.navigateByUrl('/');
    }
  }
}
